module.exports = __webpack_public_path__ + "static/media/icn-chevron-rigth-8px-13px.3360d300.svg";